import { Component } from '@angular/core';

@Component({
  selector: 'app-pending-approval',
  templateUrl: './pending-approval.component.html',
  styleUrls: ['./pending-approval.component.scss'],
  standalone: false
})
export class PendingApprovalComponent {

}
